import { writable } from 'svelte/store';

export const searchStore = writable({ loading: false, loaded: false, rawData: {}, overlayHidden: true });

export const updateKeys = (obj) => searchStore.update((oldSearchStore) => ({ ...oldSearchStore, ...obj }));
